const WORDS = ["Talent", "Precision", "Trust", "Ambition", "Growth", "People"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      className="py-10 md:py-16 border-y border-[#e4e4e7] overflow-hidden bg-white"
    >
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className="font-accent italic text-4xl md:text-7xl text-[#a1a1aa] px-10 md:px-16">
                  {w}
                </span>
                <span className="w-2 h-2 bg-[#ff3b30] rounded-full shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
